const undefinedIfNaN = (x: number) => (isNaN(x) ? undefined : x);

export function convertToCents(x: number) {
    return x * 100;
}

export function parseNumber(value: string | undefined): number | undefined;
export function parseNumber(value: string | undefined, defaultValue: number): number;
export function parseNumber(value: string | undefined, defaultValue?: number): number | undefined {
    return undefinedIfNaN(parseFloat((value ?? '').replace(/[^\d.]/g, ''))) ?? defaultValue;
}